<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">Born in 1962, Melbourne, Australia, the author has lived on a small island in South East Queensland, Australia, since 2007. She studied and worked in Sweden for five years before returning to Australia with her two sons. She worked in media and charity before undertaking studies in social science and neuro-linguistic programming, becoming a qualified councillor and international life coach. She was awarded the Hazel Hawke Scholarship to study at Curtin University and went on to work with primary school students, mentoring and working primarily in areas of social skilling and behaviour.</p><br/>
<p style="text-indent: 00em;">Inspired by her environment and her students, the author wrote the first book of the ‘Mangrove Sands’ series after retirement in 2018. She self-published a book about her beloved canine, Sir Charles Barkley, who died in 2020, donating the proceeds from sales to WIRES animal rescue.</p><br/>
<p style="text-indent: 00em;">The author continues to write children’s books at her peaceful island home in South East Queensland.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5776f5aa